module.exports = __webpack_public_path__ + "media/images/products/fmt100/fmt100-1-400x400-8a78cdae0eb936869da9c639db0c4e42.png";